import { isMobileDevice } from "@hg/recall-frame"
import React, { FC, useEffect, useState } from "react"

import { Modal } from "@/components/Modal"

import styles from "./index.module.scss"
import { Keyboard } from "./Keyboard"

export const CodeInput: FC<{
    type?: "number" | "full" | "default"
    value?: string
    placeholder?: string
    onChange?: (val: string) => void
    maxLength?: number
}> = ({
    value = "",
    onChange,
    maxLength = 12,
    type = "default",
    placeholder = "",
}) => {
    const isMobile = isMobileDevice()
    const [showKeyboard, setShowKeyboard] = useState(false)
    const [val, setVal] = useState(value)

    // 当外部 value 变化时，同步更新内部 val
    useEffect(() => {
        setVal(value)
    }, [value])

    const onKeyPress = (key: string) => {
        setVal((v) => (v + key).slice(0, maxLength))
    }

    const handleConfirm = () => {
        setShowKeyboard(false)
        val && onChange?.(val)
    }

    const handleClose = () => {
        setShowKeyboard(false)
        setVal(value) // 重置为原始值
    }

    return (
        <>
            <div
                className={styles.codeInput}
                onClick={
                    isMobile
                        ? () => {
                              setVal(value)
                              setShowKeyboard(true)
                          }
                        : undefined
                }
            >
                <div className={styles.inner}>
                    {/* <div className={styles.label}>{label}</div> */}
                    <input
                        value={value}
                        inputMode="none"
                        onChange={(e) =>
                            onChange?.(e.target.value.substring(0, maxLength))
                        }
                        placeholder={placeholder}
                    />
                </div>
            </div>
            <Modal pure open={showKeyboard} onClose={handleClose}>
                <Keyboard
                    type={type}
                    value={val}
                    maxLength={maxLength}
                    onKeyPress={onKeyPress}
                    onValueChange={setVal}
                    onClear={() => setVal("")}
                    onConfirm={handleConfirm}
                />
            </Modal>
        </>
    )
}
